import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import './styles/index.css';

// Versión nueva desplegada con la pestaña abierta: los módulos que se cargan
// bajo demanda (PowerPoint del informe, etc.) tienen hash en el nombre y el
// despliegue reemplaza el contenedor completo, así que la pestaña vieja pide un
// archivo que ya no existe ("Failed to fetch dynamically imported module").
// Vite emite `vite:preloadError` en ese caso: recargamos UNA vez (los filtros
// viven en la URL, no se pierde el contexto). Si tras recargar vuelve a fallar,
// dejamos que el error salga normal para no entrar en bucle.
const RECARGA_KEY = 'jidokap:recarga-por-version-nueva';
window.addEventListener('vite:preloadError', (event) => {
  let yaRecargado = false;
  try {
    yaRecargado = sessionStorage.getItem(RECARGA_KEY) === '1';
  } catch {
    /* sessionStorage no disponible → recargamos igual una sola vez por evento */
  }
  if (yaRecargado) return;
  event.preventDefault();
  try {
    sessionStorage.setItem(RECARGA_KEY, '1');
  } catch {
    /* sin storage no hay guarda; el navegador rara vez cae acá */
  }
  window.location.reload();
});
// Si la carga posterior sale bien, se libera la guarda para el próximo despliegue.
window.addEventListener('load', () => {
  try {
    sessionStorage.removeItem(RECARGA_KEY);
  } catch {
    /* nada que liberar */
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Missing #root element in index.html');

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
